import type { GetLoanAchRequestsQuery } from '../../../../__generated__/graphql/api';

type RawList = NonNullable<NonNullable<GetLoanAchRequestsQuery['loanAchRequests']>['achRequests']>;

type RawAchRequest = NonNullable<RawList[number]>;

export interface UserAchRequestListItem {
  id: string;
  achType: string | null;
  amountCents: number | null;
  status: string | null;
  failureReason: string | null;
  returnCode: string | null;
  returnInitiatedAt: string | null;
  returnProcessedAt: string | null;
  settledAt: string | null;
  insertedAt: string | null;
}

export const toUserAchRequestListItem = (req: RawAchRequest): UserAchRequestListItem => ({
  id: req.id,
  achType: req.achType ?? null,
  amountCents: req.amountCents ?? null,
  status: req.status ?? null,
  failureReason: req.failureReason ?? null,
  returnCode: req.returnCode ?? null,
  returnInitiatedAt: req.returnInitiatedAt ?? null,
  returnProcessedAt: req.returnProcessedAt ?? null,
  settledAt: req.settledAt ?? null,
  insertedAt: req.insertedAt ?? null,
});
